import { POST_CARD_TO_VERIFONE_REQUEST } from 'redux/modules/payment/actions/types';

const reducer = state => ({
  ...state,
  currentApiRequest: POST_CARD_TO_VERIFONE_REQUEST,
});

export default reducer;
